import React from 'react';

import XtraSvgIcon from '../../XtraSvgIcon';

// Referenece: https://github.com/mui-org/material-ui/blob/master/packages/material-ui-icons/src/utils/createSvgIcon.js
const createSvgIcon = (path: any, displayName: string, options: Record<string, any> = {}) => {
  const {
    width, height, fontSize, viewBox,
  } = options;
  const Component = React.memo(
    React.forwardRef((props: any, ref) => (
      <XtraSvgIcon
        width={width}
        height={height}
        fontSize={fontSize}
        viewBox={viewBox}
        ref={ref}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        { path }
      </XtraSvgIcon>
    )),
  );

  if (process.env.NODE_ENV !== 'production') {
    Component.displayName = `${displayName}Icon`;
  }

  return Component;
};

export default createSvgIcon;
